import React, { useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
  import {
   Button,
   TextField,
   Grid,
   Box,
   Typography,
   Paper
  } from "@material-ui/core";
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { login } from "./../../../store/actions";
import * as paths from "./../../../Routes/paths";
// import { auth, analytics } from './../firebase';
import BackgroundOverlay from './../../BackgroundOverlay';
const backgroundImage = 'https://source.unsplash.com/5E5N49RWtbA';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
  },
  image: {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '79vh',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

type UserInfo = {
  email: string;
  password: string;
};

const AgentLogin = () => {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    email: '',
    password: '',
  });
  const [disabled, setDisabled] = useState(false)

  const history = useHistory()

  const dispatch = useDispatch()
  const { authError } = useSelector((state: any) => {
    return state;
  });


  const userType = 'agents';
  const submitForm = (event: React.FormEvent) => {
    event.preventDefault();
    setDisabled(true)
    const url = "https://betastore-staging.herokuapp.com/api/v1/agents/login"
    try{
        dispatch(login(url, userInfo, paths.VIEW_PRODUCTS_AGENTS, history, userType))
    }catch(e) {
      console.log("an error occured")
    }finally{
      setDisabled(false)
    }
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.currentTarget;

    setUserInfo((info) => ({
      ...info,
      [name]: value,
    }));
  };
  const classes = useStyles();
  return (
    <div className={classes.root}>
    <Grid container component="main">
      <Grid item xs={false} sm={4} md={7}>
        <BackgroundOverlay backgroundClassName={classes.image}>
          {/* Increase the network loading priority of the background image. */}
        <img style={{ display: 'none' }} src={backgroundImage} alt="increase priority" />
        <Typography color="inherit" align="center" variant="h5">
          Register with betastore 
        </Typography>
        </BackgroundOverlay>
      </Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
        <form className={classes.form} onSubmit={(e) => submitForm(e)}>
          {authError.state && <Alert severity="error">{authError.message}</Alert>}
          <TextField
            margin="normal"
            required
            fullWidth
            id="phone"
            label="Email"
            name="email"
            type="email"
            placeholder="Enter email"
            value={userInfo.email}
            onChange={(e) => onChangeHandler(e)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            placeholder="Enter your password"
            value={userInfo.password}
            onChange={(e) => onChangeHandler(e)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submit}
            disabled={disabled}
          >
            Sign In
          </Button>
        </form>
      <Box mt={3} />
        <Typography>Or</Typography>
        <Grid container>
            <Grid item>
              <Link to={paths.LOGIN}>{"Login as a customer"}</Link>
            </Grid>
          </Grid>
      </div>
      </Grid>
    </Grid>
    </div>
  )};

export default AgentLogin;
